/* Flowersbyninaa — logique du site
   Comment installer:
   1. Modifier le code > Assets > Ajouter un nouvel asset > coller ce fichier
   2. Nomme-le exactement: flowersbyninaa.js
*/
(function(){
  "use strict";

  function money(n){
    return n.toLocaleString('fr-CA', {minimumFractionDigits: (n % 1 === 0 ? 0 : 2)}) + ' $';
  }

  function roseSVG(cx, cy, r, fill){
    return '<circle cx="'+cx+'" cy="'+cy+'" r="'+r+'" fill="'+fill+'" stroke="#00000022" stroke-width="1"/>' +
      '<circle cx="'+cx+'" cy="'+cy+'" r="'+(r*0.62)+'" fill="none" stroke="#ffffff55" stroke-width="1.2"/>' +
      '<circle cx="'+cx+'" cy="'+cy+'" r="'+(r*0.3)+'" fill="none" stroke="#ffffff55" stroke-width="1"/>';
  }
  function buildBouquetSVG(count){
    count = parseInt(count, 10) || 1;
    var cols = Math.min(7, Math.ceil(Math.sqrt(count*1.4)));
    var rows = Math.ceil(count/cols);
    var spacing = 26;
    var startX = 150 - ((cols-1)*spacing)/2;
    var startY = 150 - ((rows-1)*spacing)/2;
    var out = ""; var i = 0;
    var shades = ["#7a1620","#a9273a","#c23a4c"];
    for(var row=0; row<rows && i<count; row++){
      for(var c=0; c<cols && i<count; c++){
        var jitter = (row%2===0)?0:spacing/2;
        var x = startX + c*spacing + jitter;
        var y = startY + row*spacing*0.86;
        out += roseSVG(x,y,11, shades[i%shades.length]);
        i++;
      }
    }
    return '<svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">'+out+'</svg>';
  }

  document.addEventListener('DOMContentLoaded', function(){
    var root = document.querySelector('.fbn');
    if(!root) return;

    // Render fallback SVGs for products without a photo
    document.querySelectorAll('.fbn-svg-slot').forEach(function(slot){
      slot.innerHTML = buildBouquetSVG(slot.getAttribute('data-roses'));
    });

    var overlay = document.getElementById('fbnOverlay');
    var modal = document.getElementById('fbnQuickViewModal');
    var cartDrawer = document.getElementById('fbnCartDrawer');
    var cartBadge = document.getElementById('fbnCartBadge');

    var extrasConfig = window.FBN_EXTRAS || [];
    var extraVariantCache = {}; // handle -> {id, price}
    var extrasFetched = false;

    var currentProduct = null;
    var currentExtras = {}; // handle -> extra config
    var currentExtraTexts = {}; // handle -> texte tapé par le client
    var currentQty = 1;
    var currentColor = null;
    var productCache = {}; // handle -> full product.js data

    var COLOR_SWATCH = {
      'rouge': '#a9273a',
      'rose': '#f3c7cc',
      'rose pale': '#f3c7cc',
      'violet pale': '#c9b6dd',
      'violet fonce': '#6f4e91',
      'mauve pale': '#c9b6dd',
      'mauve fonce': '#6f4e91',
      'blanc': '#ffffff',
      'beige': '#e8dcc8',
      'bleu pale': '#b8d4e8',
      'bleu fonce': '#2c4f70'
    };
    function normalizeColorKey(str){
      return (str || '')
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // retire les accents
        .replace(/[^a-z ]/g, '')
        .trim();
    }
    function swatchColor(name){
      return COLOR_SWATCH[normalizeColorKey(name)] || '#cccccc';
    }

    /* ---------- fetch extra variant ids once ---------- */
    function ensureExtrasLoaded(cb){
      if(extrasFetched){ cb(); return; }
      var handles = extrasConfig.map(function(e){ return e.handle; }).filter(Boolean);
      var remaining = handles.length;
      if(remaining === 0){ extrasFetched = true; cb(); return; }
      handles.forEach(function(handle){
        fetch('/products/' + handle + '.js')
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(data){
            if(data && data.variants && data.variants[0]){
              extraVariantCache[handle] = { id: data.variants[0].id, price: data.variants[0].price / 100 };
            }
          })
          .catch(function(){})
          .finally(function(){
            remaining--;
            if(remaining <= 0){ extrasFetched = true; cb(); }
          });
      });
    }

    /* ---------- quick view ---------- */
    var TEXT_EXTRA_KEYWORDS = ['arabe', 'initiale', 'ruban'];
    function isTextExtra(name){
      var n = (name || '').toLowerCase();
      return TEXT_EXTRA_KEYWORDS.some(function(k){ return n.indexOf(k) !== -1; });
    }
    function textExtraPlaceholder(name){
      var n = (name || '').toLowerCase();
      if(n.indexOf('arabe') !== -1) return 'Écris le prénom à afficher en arabe';
      if(n.indexOf('initiale') !== -1) return 'Ton initiale (ex: A)';
      if(n.indexOf('ruban') !== -1) return 'Ton message pour le ruban';
      return 'Précise ta demande';
    }

    function isSingleRoseProduct(product){
      if(!product) return false;
      var t = (product.title || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return t.indexOf('etincelle') !== -1;
    }

    function openQuickView(card){
      var handle = card.getAttribute('data-handle');
      var imagesRaw = card.getAttribute('data-images');
      var images = [];
      try { images = JSON.parse(imagesRaw) || []; } catch(e){ images = []; }

      currentProduct = {
        id: card.getAttribute('data-product-id'),
        handle: handle,
        variantId: card.getAttribute('data-variant-id'),
        title: card.getAttribute('data-title'),
        price: parseFloat(card.getAttribute('data-price')),
        desc: card.getAttribute('data-desc'),
        roses: card.getAttribute('data-roses'),
        image: card.getAttribute('data-image'),
        images: images
      };
      currentExtras = {};
      currentExtraTexts = {};
      currentQty = 1;
      currentColor = null;
      document.getElementById('fbnOrderNote').value = '';

      renderGallery(images.length ? images.map(function(i){ return i.url; }) : (currentProduct.image ? [currentProduct.image] : []));

      document.getElementById('fbnModalName').textContent = currentProduct.title;
      document.getElementById('fbnModalDesc').textContent = currentProduct.desc;
      document.getElementById('fbnModalBasePrice').textContent = money(currentProduct.price);
      document.getElementById('fbnQtyValue').textContent = '1';

      var colorLabelEl = document.getElementById('fbnColorSelectedLabel');
      if(colorLabelEl){ colorLabelEl.classList.remove('show'); colorLabelEl.textContent = ''; }
      renderColorSwatches(null);
      if(handle){
        loadFullProduct(handle, function(data){
          if(data) renderColorSwatches(data);
        });
      }

      var extrasWrap = document.getElementById('fbnModalExtras');
      extrasWrap.innerHTML = '';

      var availableExtras = extrasConfig;
      if(isSingleRoseProduct(currentProduct)){
        availableExtras = extrasConfig.filter(function(ex){
          var n = (ex.name || '').toLowerCase();
          return n.indexOf('toutou') !== -1 || n.indexOf('paillette') !== -1;
        });
      }

      availableExtras.forEach(function(ex){
        var wrap = document.createElement('div');
        wrap.className = 'fbn-extra-wrap';

        var row = document.createElement('div');
        row.className = 'fbn-extra-opt';
        row.setAttribute('role', 'checkbox');
        row.setAttribute('aria-checked', 'false');
        row.setAttribute('tabindex', '0');
        row.innerHTML = '<span class="fbn-toggle"><span class="fbn-toggle-dot"></span></span>' +
          '<span class="fbn-exicon">'+ex.icon+'</span>' +
          '<span class="fbn-exname">'+ex.name+'</span>' +
          '<span class="fbn-exprice">+'+ex.price+' $</span>';
        wrap.appendChild(row);

        var needsText = isTextExtra(ex.name);
        var textWrap = null, textInput = null;
        if(needsText){
          textWrap = document.createElement('div');
          textWrap.className = 'fbn-extra-textwrap';
          textInput = document.createElement('input');
          textInput.type = 'text';
          textInput.placeholder = textExtraPlaceholder(ex.name);
          textInput.maxLength = 60;
          textInput.addEventListener('click', function(e){ e.stopPropagation(); });
          textInput.addEventListener('input', function(){
            currentExtraTexts[ex.handle] = textInput.value;
          });
          textWrap.appendChild(textInput);
          wrap.appendChild(textWrap);
        }

        function toggle(){
          var isActive = row.classList.contains('active');
          if(!isActive){
            currentExtras[ex.handle] = ex;
            row.classList.add('active');
            row.setAttribute('aria-checked', 'true');
            if(textWrap){ textWrap.classList.add('open'); setTimeout(function(){ textInput.focus(); }, 220); }
          } else {
            delete currentExtras[ex.handle];
            row.classList.remove('active');
            row.setAttribute('aria-checked', 'false');
            if(textWrap){ textWrap.classList.remove('open'); }
          }
          updateModalTotal();
        }
        row.addEventListener('click', function(e){ e.preventDefault(); toggle(); });
        row.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); }
        });
        extrasWrap.appendChild(wrap);
      });

      updateModalTotal();
      overlay.classList.add('open');
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';

      ensureExtrasLoaded(function(){});
    }

    function renderGallery(urls){
      var mainWrap = document.getElementById('fbnModalImg');
      var thumbsWrap = document.getElementById('fbnModalThumbs');
      thumbsWrap.innerHTML = '';

      if(!urls.length){
        mainWrap.innerHTML = buildBouquetSVG(currentProduct.roses);
        thumbsWrap.style.display = 'none';
        return;
      }

      function setMain(url){
        mainWrap.innerHTML = '<img src="'+url+'" alt="'+currentProduct.title+'">';
        thumbsWrap.querySelectorAll('.fbn-thumb-btn').forEach(function(b){
          b.classList.toggle('active', b.getAttribute('data-url') === url);
        });
      }

      if(urls.length > 1){
        thumbsWrap.style.display = 'flex';
        urls.forEach(function(url){
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fbn-thumb-btn';
          btn.setAttribute('data-url', url);
          btn.innerHTML = '<img src="'+url+'" alt="">';
          btn.addEventListener('click', function(){ setMain(url); });
          thumbsWrap.appendChild(btn);
        });
      } else {
        thumbsWrap.style.display = 'none';
      }

      setMain(urls[0]);
    }

    function loadFullProduct(handle, cb){
      if(productCache[handle]){ cb(productCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){ if(data) productCache[handle] = data; cb(data); })
        .catch(function(){ cb(null); });
    }

    function renderColorSwatches(data){
      var section = document.getElementById('fbnColorSection');
      var wrap = document.getElementById('fbnColorSwatches');
      if(!section || !wrap) return;

      // Pas de choix de couleur pour les produits à 1 rose (ex: L'Étincelle) — une seule couleur possible
      if(currentProduct && isSingleRoseProduct(currentProduct)){
        section.style.display = 'none';
        return;
      }

      if(!data || !data.variants || data.variants.length < 2){
        section.style.display = 'none';
        return;
      }

      // color values come from option1 of each variant — le produit doit avoir
      // une seule option nommée "Couleur" dans Shopify
      var seen = {};
      var colors = [];
      data.variants.forEach(function(v){
        if(v.option1 && !seen[v.option1]){ seen[v.option1] = true; colors.push(v.option1); }
      });
      if(colors.length < 2){ section.style.display = 'none'; return; }

      section.style.display = 'block';
      wrap.innerHTML = '';
      currentColor = colors[0];

      colors.forEach(function(colorName){
        var sw = document.createElement('button');
        sw.type = 'button';
        sw.className = 'fbn-swatch' + (colorName === currentColor ? ' active' : '');
        sw.style.background = swatchColor(colorName);
        sw.setAttribute('data-color', colorName);
        sw.addEventListener('click', function(){
          currentColor = colorName;
          wrap.querySelectorAll('.fbn-swatch').forEach(function(s){ s.classList.remove('active'); });
          sw.classList.add('active');
          applyColorSelection(data);
        });
        wrap.appendChild(sw);
      });

      applyColorSelection(data);
    }

    function updateColorLabel(name){
      var label = document.getElementById('fbnColorSelectedLabel');
      if(!label) return;
      label.classList.remove('show');
      clearTimeout(label._fadeTimeout);
      label._fadeTimeout = setTimeout(function(){
        label.textContent = name;
        var hex = swatchColor(name);
        // le blanc est illisible sur le fond crème du site, on garde une couleur foncée dans ce cas
        label.style.color = (hex.toLowerCase() === '#ffffff') ? 'var(--fbn-ink)' : hex;
        label.classList.add('show');
      }, 160);
    }

    function applyColorSelection(data){
      var match = data.variants.find(function(v){ return v.option1 === currentColor; });
      if(match){
        currentProduct.variantId = match.id;
        currentProduct.price = match.price / 100;
        document.getElementById('fbnModalBasePrice').textContent = money(currentProduct.price);
        updateColorLabel(currentColor);
        if(match.featured_image && match.featured_image.src){
          document.getElementById('fbnModalImg').innerHTML = '<img src="'+match.featured_image.src+'" alt="'+currentProduct.title+'">';
          document.querySelectorAll('#fbnModalThumbs .fbn-thumb-btn').forEach(function(b){ b.classList.remove('active'); });
        }
        updateModalTotal();
      }
    }

    function closeQuickView(){
      overlay.classList.remove('open');
      modal.classList.remove('open');
      if(!cartDrawer.classList.contains('open')) document.body.style.overflow = '';
    }

    function updateModalTotal(){
      var total = currentProduct.price;
      Object.keys(currentExtras).forEach(function(h){ total += currentExtras[h].price; });
      total *= currentQty;
      document.getElementById('fbnModalTotal').textContent = money(total);
    }

    document.querySelectorAll('.fbn-card').forEach(function(card){
      card.addEventListener('click', function(){ openQuickView(card); });

      var imagesRaw = card.getAttribute('data-images');
      var cardImages = [];
      try { cardImages = JSON.parse(imagesRaw) || []; } catch(e){ cardImages = []; }

      if(cardImages.length > 1){
        var imgBox = card.querySelector('.fbn-card-img');
        var imgEl = imgBox.querySelector('img');
        var idx = 0;

        function showCardImage(i){
          idx = (i + cardImages.length) % cardImages.length;
          if(imgEl) imgEl.src = cardImages[idx].url;
        }

        var prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'fbn-card-nav fbn-card-nav-prev';
        prevBtn.setAttribute('aria-label', 'Photo précédente');
        prevBtn.textContent = '‹';
        prevBtn.addEventListener('click', function(e){ e.stopPropagation(); showCardImage(idx - 1); });

        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'fbn-card-nav fbn-card-nav-next';
        nextBtn.setAttribute('aria-label', 'Photo suivante');
        nextBtn.textContent = '›';
        nextBtn.addEventListener('click', function(e){ e.stopPropagation(); showCardImage(idx + 1); });

        imgBox.appendChild(prevBtn);
        imgBox.appendChild(nextBtn);
      }
    });
    document.getElementById('fbnModalCloseBtn').addEventListener('click', closeQuickView);

    document.getElementById('fbnQtyMinus').addEventListener('click', function(){
      if(currentQty > 1){ currentQty--; document.getElementById('fbnQtyValue').textContent = currentQty; updateModalTotal(); }
    });
    document.getElementById('fbnQtyPlus').addEventListener('click', function(){
      currentQty++; document.getElementById('fbnQtyValue').textContent = currentQty; updateModalTotal();
    });

    /* ---------- add to cart (real Shopify AJAX cart) ---------- */
    function buildCartItems(){
      var mainProps = { "Bouquet": currentProduct.title };
      if(currentColor) mainProps["Couleur"] = currentColor;
      var noteEl = document.getElementById('fbnOrderNote');
      if(noteEl && noteEl.value.trim()){
        mainProps["Note du client"] = noteEl.value.trim();
      }

      var items = [{
        id: currentProduct.variantId,
        quantity: currentQty,
        properties: mainProps
      }];

      Object.keys(currentExtras).forEach(function(handle){
        var cached = extraVariantCache[handle];
        if(cached){
          var props = { "Pour le bouquet": currentProduct.title, "Extra": currentExtras[handle].name };
          var typedText = currentExtraTexts[handle];
          if(typedText && typedText.trim()){
            props["Personnalisation demandée"] = typedText.trim();
          }
          items.push({
            id: cached.id,
            quantity: currentQty,
            properties: props
          });
        }
      });
      return items;
    }

    function addItemsToCart(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r){
        return r.json().then(function(data){
          if(!r.ok || data.status){
            var msg = (data && (data.description || data.message)) || ('Erreur ' + r.status);
            console.error('Cart add failed:', data);
            throw new Error(msg);
          }
          return data;
        });
      });
    }

    var addBtn = document.getElementById('fbnAddToCartBtn');
    function validateExtraTexts(){
      for(var handle in currentExtras){
        if(isTextExtra(currentExtras[handle].name)){
          var val = (currentExtraTexts[handle] || '').trim();
          if(!val){
            showToast('Écris ta demande pour "' + currentExtras[handle].name + '" avant d\'ajouter');
            return false;
          }
        }
      }
      return true;
    }

    addBtn.addEventListener('click', function(){
      if(!validateExtraTexts()) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Ajout en cours…';

      ensureExtrasLoaded(function(){
        addItemsToCart(buildCartItems())
        .then(function(){ return refreshCart(); })
        .then(function(){
          addBtn.disabled = false;
          addBtn.textContent = 'Ajouter au panier';
          showToast();
          closeQuickView();
          openCart();
        })
        .catch(function(err){
          console.error('Erreur ajout panier', err);
          addBtn.disabled = false;
          addBtn.textContent = 'Ajouter au panier';
          showToast(err && err.message ? err.message : 'Erreur — réessaie');
        });
      });
    });

    var buyNowBtn = document.getElementById('fbnBuyNowBtn');
    buyNowBtn.addEventListener('click', function(){
      if(!validateExtraTexts()) return;
      buyNowBtn.disabled = true;
      addBtn.disabled = true;
      buyNowBtn.textContent = 'Redirection…';

      ensureExtrasLoaded(function(){
        addItemsToCart(buildCartItems())
        .then(function(){
          window.location.href = '/checkout';
        })
        .catch(function(err){
          console.error('Erreur achat direct', err);
          buyNowBtn.disabled = false;
          addBtn.disabled = false;
          buyNowBtn.textContent = 'Acheter maintenant';
          showToast(err && err.message ? err.message : 'Erreur — réessaie');
        });
      });
    });

    /* ---------- cart drawer (reads real Shopify cart) ---------- */
    function openCart(){
      overlay.classList.add('open');
      cartDrawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }
    function closeCart(){
      cartDrawer.classList.remove('open');
      if(!modal.classList.contains('open')){ overlay.classList.remove('open'); document.body.style.overflow = ''; }
    }
    document.getElementById('fbnCartOpenBtn').addEventListener('click', openCart);
    document.getElementById('fbnCartCloseBtn').addEventListener('click', closeCart);

    /* ---------- contact popup ---------- */
    var contactModal = document.getElementById('fbnContactModal');
    function openContact(){
      overlay.classList.add('open');
      contactModal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeContact(){
      contactModal.classList.remove('open');
      if(!modal.classList.contains('open') && !cartDrawer.classList.contains('open')){
        overlay.classList.remove('open');
        document.body.style.overflow = '';
      }
    }
    var contactNavBtn = document.getElementById('fbnContactNavBtn');
    var contactMobileBtn = document.getElementById('fbnContactMobileBtn');
    if(contactNavBtn) contactNavBtn.addEventListener('click', openContact);
    if(contactMobileBtn) contactMobileBtn.addEventListener('click', function(){ closeMobileMenu(); openContact(); });
    document.getElementById('fbnContactCloseBtn').addEventListener('click', closeContact);

    function closeAll(){ closeQuickView(); closeCart(); closeContact(); }
    overlay.addEventListener('click', closeAll);
    overlay.addEventListener('touchend', function(e){ e.preventDefault(); closeAll(); }, { passive:false });
    // clicking/tapping outside the modal box or drawer also closes (extra safety net)
    document.addEventListener('click', function(e){
      if(modal.classList.contains('open') && !modal.contains(e.target) && e.target !== overlay){
        if(!e.target.closest('.fbn-card')) closeQuickView();
      }
      if(cartDrawer.classList.contains('open') && !cartDrawer.contains(e.target) && !e.target.closest('#fbnCartOpenBtn')){
        closeCart();
      }
      if(contactModal.classList.contains('open') && !contactModal.contains(e.target) && e.target !== overlay
         && !e.target.closest('#fbnContactNavBtn') && !e.target.closest('#fbnContactMobileBtn')){
        closeContact();
      }
    });

    function refreshCart(){
      return fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){ renderCart(cart); return cart; });
    }

    function renderCart(cart){
      cartBadge.textContent = cart.item_count;
      var countEl = document.getElementById('fbnCartCount');
      if(countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

      var wrap = document.getElementById('fbnCartItems');
      var foot = document.getElementById('fbnCartFoot');

      if(cart.item_count === 0){
        wrap.innerHTML = '<div class="fbn-cart-empty">Ton panier est vide.<br>Ajoute un bouquet pour commencer ✨</div>';
        foot.style.display = 'none';
        return;
      }
      foot.style.display = 'block';
      wrap.innerHTML = '';
      cart.items.forEach(function(item, index){
        var thumb = item.image ? '<img src="'+item.image+'" alt="">' : buildBouquetSVG(6);
        var propsText = '';
        if(item.properties){
          var parts = [];
          Object.keys(item.properties).forEach(function(k){
            if(item.properties[k]) parts.push(item.properties[k]);
          });
          propsText = parts.join(' · ');
        }
        var row = document.createElement('div');
        row.className = 'fbn-cart-item';
        row.innerHTML =
          '<div class="fbn-thumb">'+thumb+'</div>' +
          '<div class="fbn-cart-item-info">' +
            '<h4>'+item.product_title+'</h4>' +
            (propsText ? '<div class="fbn-exlist">'+propsText+'</div>' : '') +
            '<div class="fbn-row">' +
              '<div class="fbn-mini-qty">' +
                '<button type="button" data-act="minus">−</button>' +
                '<span>'+item.quantity+'</span>' +
                '<button type="button" data-act="plus">+</button>' +
              '</div>' +
              '<span class="fbn-price">'+money(item.final_line_price/100)+'</span>' +
            '</div>' +
          '</div>' +
          '<button class="fbn-removebtn" aria-label="Retirer">✕</button>';

        row.querySelector('[data-act="minus"]').addEventListener('click', function(){
          changeLine(index + 1, Math.max(0, item.quantity - 1));
        });
        row.querySelector('[data-act="plus"]').addEventListener('click', function(){
          changeLine(index + 1, item.quantity + 1);
        });
        row.querySelector('.fbn-removebtn').addEventListener('click', function(){
          changeLine(index + 1, 0);
        });
        wrap.appendChild(row);
      });
      document.getElementById('fbnCartSubtotal').textContent = money(cart.total_price/100);
      document.getElementById('fbnCartTotal').textContent = money(cart.total_price/100);
    }

    function changeLine(line, quantity){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); });
    }

    document.getElementById('fbnCheckoutBtn').addEventListener('click', function(){
      window.location.href = '/checkout';
    });

    /* ---------- upsell add buttons ---------- */
    document.querySelectorAll('.fbn-upsell-card').forEach(function(card){
      var btn = card.querySelector('.fbn-upsell-add');
      var variantId = card.getAttribute('data-variant-id');
      if(!btn || !variantId) return;
      btn.addEventListener('click', function(){
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = '…';
        addItemsToCart([{ id: variantId, quantity: 1 }])
          .then(function(){ return refreshCart(); })
          .then(function(){ btn.disabled = false; btn.textContent = original; showToast(); })
          .catch(function(err){
            btn.disabled = false;
            btn.textContent = original;
            showToast(err && err.message ? err.message : 'Erreur — réessaie');
          });
      });
    });

    /* ---------- promo code (redirige via le système natif Shopify) ---------- */
    var promoBtn = document.getElementById('fbnPromoApply');
    var promoInput = document.getElementById('fbnPromoInput');
    if(promoBtn && promoInput){
      promoBtn.addEventListener('click', function(){
        var code = promoInput.value.trim();
        if(!code) return;
        var returnTo = window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'fbn_cart=1';
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(returnTo);
      });
      promoInput.addEventListener('keydown', function(e){
        if(e.key === 'Enter') promoBtn.click();
      });
    }

    // si on revient d'une application de code promo, rouvrir le panier automatiquement
    if(window.location.search.indexOf('fbn_cart=1') !== -1){
      openCart();
      var cleanUrl = window.location.pathname + window.location.search.replace(/[?&]fbn_cart=1/, '').replace(/^&/, '?');
      history.replaceState(null, '', cleanUrl || window.location.pathname);
    }

    /* ---------- toast ---------- */
    function showToast(msg){
      var t = document.getElementById('fbnToast');
      t.textContent = msg || 'Ajouté au panier ✨';
      t.classList.add('show');
      setTimeout(function(){ t.classList.remove('show'); }, 2200);
    }

    /* ---------- mobile menu ---------- */
    var burgerBtn = document.getElementById('fbnBurgerBtn');
    var mobileMenu = document.getElementById('fbnMobileMenu');
    burgerBtn.addEventListener('click', function(){
      burgerBtn.classList.toggle('open');
      mobileMenu.classList.toggle('open');
    });
    document.getElementById('fbnMobileCloseBtn').addEventListener('click', closeMobileMenu);
    mobileMenu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', closeMobileMenu);
    });
    function closeMobileMenu(){
      burgerBtn.classList.remove('open');
      mobileMenu.classList.remove('open');
    }

    /* ---------- init cart badge on load ---------- */
    refreshCart();

    /* ---------- always-on carousel: never pauses, no drag (avis) ---------- */
    function initAutoCarousel(viewportSel, trackSel, speed, key){
      var viewport = document.querySelector(viewportSel);
      var track = document.querySelector(trackSel);
      if(!track) return;
      var pos = 0;
      var halfWidth = 0;
      var dragging = false;
      var dragStartX = 0;
      var dragStartPos = 0;

      function measure(){ halfWidth = track.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure);

      function wrap(){
        if(pos > 0) pos -= halfWidth;
        if(pos <= -halfWidth) pos += halfWidth;
      }

      function tick(){
        if(!dragging){
          pos -= speed;
          wrap();
        }
        track.style.transform = 'translateX(' + pos + 'px)';
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      if(viewport){
        function getX(e){ return e.touches ? e.touches[0].clientX : e.clientX; }
        function onDown(e){ dragging = true; dragStartX = getX(e); dragStartPos = pos; }
        function onMove(e){
          if(!dragging) return;
          pos = dragStartPos + (getX(e) - dragStartX);
          wrap();
        }
        function onUp(){ dragging = false; }
        viewport.addEventListener('touchstart', onDown, { passive:true });
        viewport.addEventListener('touchmove', onMove, { passive:true });
        viewport.addEventListener('touchend', onUp);
        viewport.addEventListener('mousedown', onDown);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
      }

      if(key){
        function stepSize(){
          var a = track.children[0], b = track.children[1];
          if(a && b) return (b.offsetLeft - a.offsetLeft);
          return 300;
        }
        function jump(dir){
          pos += (dir === 'next') ? -stepSize() : stepSize();
          wrap();
        }
        var prevBtn = document.querySelector('[data-carousel-prev="'+key+'"]');
        var nextBtn = document.querySelector('[data-carousel-next="'+key+'"]');
        if(prevBtn) prevBtn.addEventListener('click', function(){ jump('prev'); });
        if(nextBtn) nextBtn.addEventListener('click', function(){ jump('next'); });
      }
    }

    /* ---------- reusable drag carousel: slow auto-scroll + drag/swipe ---------- */
    function initDragCarousel(viewportSel, trackSel, speed){
      var viewport = document.querySelector(viewportSel);
      var track = document.querySelector(trackSel);
      if(!viewport || !track) return;

      var pos = 0;
      var halfWidth = 0;
      var paused = false;
      var dragging = false;
      var dragStartX = 0;
      var dragStartPos = 0;

      function measure(){ halfWidth = track.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure);

      function tick(){
        if(!paused && !dragging){
          pos -= speed;
          if(pos <= -halfWidth) pos += halfWidth;
          track.style.transform = 'translateX(' + pos + 'px)';
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      function getX(e){ return e.touches ? e.touches[0].clientX : e.clientX; }

      function onDown(e){
        dragging = true;
        dragStartX = getX(e);
        dragStartPos = pos;
      }
      function onMove(e){
        if(!dragging) return;
        var dx = getX(e) - dragStartX;
        pos = dragStartPos + dx;
        if(pos > 0) pos -= halfWidth;
        if(pos < -halfWidth) pos += halfWidth;
        track.style.transform = 'translateX(' + pos + 'px)';
      }
      function onUp(){ dragging = false; }

      viewport.addEventListener('mousedown', onDown);
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
      viewport.addEventListener('touchstart', onDown, { passive:true });
      viewport.addEventListener('touchmove', onMove, { passive:true });
      viewport.addEventListener('touchend', onUp);

      viewport.addEventListener('mouseenter', function(){ paused = true; });
      viewport.addEventListener('mouseleave', function(){ paused = false; });
    }

    /* ---------- scroll reveal: sections & product cards slide up as they enter view ---------- */
    (function initScrollReveal(){
      var els = document.querySelectorAll('.fbn-reveal');
      if(!els.length) return;
      if(!('IntersectionObserver' in window)){
        els.forEach(function(el){ el.classList.add('in-view'); });
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      els.forEach(function(el){ io.observe(el); });
    })();

    initAutoCarousel('.fbn-testi-viewport', '.fbn-testi-track', 0.28, 'testi');
    initAutoCarousel('.fbn-clientphotos-viewport', '.fbn-clientphotos-track', 0.6, 'clientphotos');
    initAutoCarousel('.fbn-trustbar-mobile-viewport', '.fbn-trustbar-mobile-track', 0.4);
  });
})();